/* Version: 5.0.5 - December 14, 2022 17:58:38 */
var src = {};

var VERSION = '5.0.5';
var refreshingToken = false;
var idTokenPromise = null;

/**
 * Verifies idToken is present in cookies and is valid.
 * Returns true if valid, false if not.
 */
function hasValidIdToken() {
  var idToken = getCookies().idToken;
  return !!(idToken && getUserUid(idToken) && isNotExpired(idToken));
}

/**
 * Verifies idToken is present in cookies otherwise redirects to accountsUrl
 * @param {string} callbackUrl the url to return to after being redirected, default is window.location
 * @param {string} accountsUrl the url of the account application
 */
function auth(accountsUrl, callbackUrl) {
  var url = callbackUrl || window.location;
  return getIdToken(accountsUrl).then(getUserUid)["catch"](function (e) {
    redirectClient(url, accountsUrl);
  });
}

/**
 * redirects client to loginUrl with url as the state parameter
 * @param {string} callbackUrl the url to be returned to after redirects
 * @param {string} accountsUrl the url for the account application
 */
function redirectClient(callbackUrl, accountsUrl) {
  var encodedUrl = encodeURIComponent(callbackUrl);
  window.location.href = accountsUrl + '/?redirect_uri=' + encodedUrl;
}

/**
 * Redirects to logoutUrl
 * @param {string} accountsUrl the logoutUrl for the account application
 */
function logout(accountsUrl) {
  window.location.href = accountsUrl + '/logout';
}

/**
 * returns Authorization header containing Beaerer IdToken
 */
function getAuthHeader(accountsUrl) {
  return getIdToken(accountsUrl).then(function (idToken) {
    return {
      Authorization: 'Bearer ' + idToken
    };
  });
}

/**
 * Gets the cookies and formats them into a map
 */
function getCookies() {
  return document.cookie.split('; ').map(function (kv) {
    return kv.split('=');
  }).reduce(function (map, arr) {
    map[arr[0]] = arr[1];
    return map;
  }, {});
}

/**
 * open the stormcrows's mock url in a new tab
 */
function mock(accountsUrl, userID) {
  var state = window.location.href;
  window.open(accountsUrl + '/mock/' + userID + '?redirect_uri=' + state);
}
var atob = window.atob || function atob(str) {
  return Buffer.from(str, 'base64').toString('binary');
};
function getUserUid(idToken) {
  var decodedToken = decodeToken(idToken);
  return decodedToken.app_metadata.user_uid;
}
function getIdToken(accountsUrl, ignoreMock) {
  // == checks that it's null OR undefined but not "false"
  if (idTokenPromise == null) {
    idTokenPromise = new Promise(function (resolve, reject) {
      var cookies = getCookies();
      var idToken = cookies.idToken;
      if (!ignoreMock && cookies.mockIdToken) {
        if (isNotExpired(cookies.mockIdToken)) {
          idToken = cookies.mockIdToken;
        } else {
          deleteCookie('mockIdToken', window.location.hostname);
        }
      }
      if (idToken) {
        resolve(idToken);
      } else {
        reject('not authenticated');
      }
    });
  }
  return idTokenPromise.then(function (idToken) {
    if (isNotExpired(idToken)) return idToken;
    throw 'expired';
  })["catch"](function () {
    if (!refreshingToken) {
      idTokenPromise = refreshToken(accountsUrl);
    }
    return idTokenPromise;
  });
}
function isNotExpired(idToken) {
  var decodedToken = decodeToken(idToken);
  if (!decodedToken) return false;
  var date = decodedToken.exp ? decodedToken.exp : null;
  // convert to millis
  return new Date(date * 1000) > Date.now();
}
function decodeToken(idToken) {
  if (idToken) {
    var tokenParts = idToken.split('.');
    return JSON.parse(atob(tokenParts[1]));
  }
  return null;
}
function reset() {
  idTokenPromise = null;
  refreshingToken = false;
}
function getRefreshTokenUrl(accountsUrl) {
  return accountsUrl + '/api/refresh_token/v3';
}
function refreshToken(accountsUrl) {
  var isRedirecting = false;
  refreshingToken = true;
  var token = getCookies().refreshToken;
  if (!token) {
    logout(accountsUrl);
    return Promise.reject('no refresh token');
  }
  var headers = {
    'Content-Type': 'application/json',
    'x-request-id': generateXRequestId(),
    'x-foe-hammer-version': VERSION
  };
  var params = {
    method: 'POST',
    headers: headers,
    redirect: 'follow',
    body: JSON.stringify({
      token: token
    })
  };
  return fetch(getRefreshTokenUrl(accountsUrl), params).then(function (response) {
    if (response.redirected) {
      isRedirecting = true;
      window.location = response.url;
    } else if (response.ok) {
      return response.text();
    } else {
      throw response.text();
    }
  }).then(function (idToken) {
    if (isRedirecting) {
      return null;
    } else {
      refreshingToken = false;
      document.cookie = createIdTokenCookie(idToken, window.location.hostname);
      return idToken;
    }
  })["catch"](function (e) {
    refreshingToken = false;
    throw e;
  });
}
function getCookieDomain(hostname) {
  var domain = hostname.replace(/[^\.]+\./, '');
  return domain === 'localhost' ? domain : '.' + domain;
}
function createIdTokenCookie(idToken, hostname) {
  var exp = decodeToken(idToken).exp;
  var expiration = new Date(exp * 1000);
  var domain = getCookieDomain(hostname);
  var useSecureCookie = window.location.protocol === 'https:';
  return 'idToken=' + idToken + '; Expires=' + expiration.toUTCString() + '; Domain=' + domain + '; Secure=' + useSecureCookie + '; SameSite=Lax';
}
function deleteCookie(cookie, hostname) {
  var expiration = new Date(0);
  var domain = getCookieDomain(hostname);
  document.cookie = cookie + '=; Expires=' + expiration.toUTCString() + '; Domain=' + domain;
}
function authorizeApp(accountsUrl, appName) {
  var url = accountsUrl + "/authorize_app/?app_name=".concat(appName);
  return getAuthHeader(accountsUrl).then(function (authHeader) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader['Authorization'],
        'x-request-id': generateXRequestId(),
        'x-foe-hammer-version': VERSION
      }
    }).then(function (r) {
      return r.json();
    }).then(function (data) {
      var authorized = Boolean(data['authorized']);
      if (!authorized) {
        window.location.href = accountsUrl + '/redirect';
      }
      return authorized;
    });
  })["catch"](function () {
    window.location.href = accountsUrl + '/redirect';
    return false;
  });
}
function generateXRequestId() {
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  var host = window.location.host;
  var appName = host.substring(0, host.length - 4);
  return "".concat(appName, "-").concat(uuid);
}
var authorizeApp_1 = src.authorizeApp = authorizeApp;
var getAuthHeader_1 = src.getAuthHeader = getAuthHeader;
var redirectClient_1 = src.redirectClient = redirectClient;
var logout_1 = src.logout = logout;
var mock_1 = src.mock = mock;
var auth_1 = src.auth = auth;
var reset_1 = src.reset = reset;
var getIdToken_1 = src.getIdToken = getIdToken;
var hasValidIdToken_1 = src.hasValidIdToken = hasValidIdToken;
var getUserUid_1 = src.getUserUid = getUserUid;
var refreshToken_1 = src.refreshToken = refreshToken;

export { auth_1 as auth, authorizeApp_1 as authorizeApp, src as default, getAuthHeader_1 as getAuthHeader, getIdToken_1 as getIdToken, getUserUid_1 as getUserUid, hasValidIdToken_1 as hasValidIdToken, logout_1 as logout, mock_1 as mock, redirectClient_1 as redirectClient, refreshToken_1 as refreshToken, reset_1 as reset };
